import { Button, InputNumber, message, Modal, Select, Table } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { getInteresMes } from "../../../lib/getInteresMes";
import { updateInteresMes } from "../../../lib/newInteresMes";


const { Option } = Select;

const MonthlyInterest = () => {
  const [interests, setInterests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingKey, setEditingKey] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [newInterestData, setNewInterestData] = useState({ month: '', year: '', interestRate: 0 });

  useEffect(() => {
    fetchInterests();
  }, []);

  const fetchInterests = async () => {
    setLoading(true);
    try {
      const response = await getInteresMes();
      setInterests(response.data);
      setLoading(false);
    } catch (error) {
      message.error('Error al obtener los intereses');
      setLoading(false);
    }
  };

  const handleSave = async (interesMes, interestRate) => {
    try {
      interesMes.interestRate= interestRate
      await updateInteresMes(interesMes);
      message.success('Interés actualizado correctamente');
      setEditingKey("")
      fetchInterests();
    } catch (error) {
      message.error('Error al actualizar el interés');
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/interests/${id}`);
      message.success('Interés eliminado correctamente');
      fetchInterests();
    } catch (error) {
      message.error('Error al eliminar el interés');
    }
  };

  const handleAdd = async () => {
    // Generamos la fecha usando el mes y año seleccionados
    const { month, year, interestRate } = newInterestData;
    const date = new Date(year, months.indexOf(month), 1); // Establecemos el día 1 del mes seleccionado
    date.setHours(0, 0, 0, 0); // Fijamos la hora a 00:00:00

    const newInterest = {
      month,
      year,
      interestRate,
      date, // Añadimos el campo date
    };

    try {
      await updateInteresMes(newInterest);
      message.success('Interés añadido correctamente');
      fetchInterests();
      setIsModalVisible(false); // Cerrar el modal después de añadir
      setNewInterestData({ month: '', year: '', interestRate: 0 }); // Reiniciar el formulario
    } catch (error) {
      message.error('Error al añadir el interés');
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setNewInterestData({ month: '', year: '', interestRate: 0 });
  };

  const handleInputChange = (field, value) => {
    setNewInterestData((prev) => ({ ...prev, [field]: value }));
  };

  const months = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];

  // Permitir años desde 5 años atrás hasta 5 años adelante
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);

  const columns = [
    {
      title: 'Mes',
      dataIndex: 'month',
      key: 'month',
    },
    {
      title: 'Año',
      dataIndex: 'year',
      key: 'year',
    },
    {
      title: 'Tasa de Interés',
      dataIndex: 'interestRate',
      key: 'interestRate',
      render: (text, record) => {
        if (editingKey === record._id) {
          return (
            <InputNumber
              defaultValue={text}
              onChange={(value) => handleSave(record, value)}
            />
          );
        }
        return text;
      },
    },
    {
      title: 'Acciones',
      key: 'action',
      render: (text, record) => (
        <>
          <Button type="link" onClick={() => setEditingKey(record._id)}>
            Editar
          </Button>
          <Button type="link" danger onClick={() => handleDelete(record._id)}>
            Eliminar
          </Button>
        </>
      ),
    },
  ];

  return (
    <div>
      <h1>Gestión de Intereses Mensuales</h1>
      <Button onClick={showModal} type="primary" style={{ marginBottom: 16 }}>
        Añadir Interés
      </Button>

      {/* Modal para agregar nuevo interés */}
      <Modal
        title="Añadir Nuevo Interés"
        visible={isModalVisible}
        onOk={handleAdd}
        onCancel={handleCancel}
        okText="Guardar"
        cancelText="Cancelar"
      >
        <div style={{ marginBottom: 16 }}>
          <label>Mes:</label>
          <Select
            style={{ width: '100%' }}
            placeholder="Selecciona un mes"
            onChange={(value) => handleInputChange('month', value)}
            value={newInterestData.month}
          >
            {months.map((month, index) => (
              <Option key={index} value={month}>
                {month}
              </Option>
            ))}
          </Select>
        </div>

        <div style={{ marginBottom: 16 }}>
          <label>Año:</label>
          <Select
            style={{ width: '100%' }}
            placeholder="Selecciona un año"
            onChange={(value) => handleInputChange('year', value)}
            value={newInterestData.year}
          >
            {years.map((year) => (
              <Option key={year} value={year}>
                {year}
              </Option>
            ))}
          </Select>
        </div>

        <div style={{ marginBottom: 16 }}>
          <label>Tasa de Interés:</label>
          <InputNumber
            style={{ width: '100%' }}
            min={0}
            max={100}
            placeholder="Introduce la tasa de interés"
            onChange={(value) => handleInputChange('interestRate', value)}
            value={newInterestData.interestRate}
          />
        </div>
      </Modal>

      <Table
        columns={columns}
        dataSource={interests}
        loading={loading}
        rowKey={(record) => record._id}
      />
    </div>
  );
};

export default MonthlyInterest;
